export const FantasySportsSection = () => {
  return (
    <>
      <div className="bg-secondary w-full mx-auto flex items-center">
        <img src="/assets/top-thumba-logo.svg" alt="Main Content Background" className="absolute" />
        <div className="text-center text-white flex-1">
          <div className="border-t border-white w-[175px] mx-auto mt-4" />
          <h2 className="text-sm font-semibold">about FANTASY SPORTS</h2>
          <div className="border-t border-white w-[175px] mx-auto" />
          <h3 className="text-xl sm:text-2xl font-bold mb-4">ファンタジースポーツとは？</h3>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row justify-center gap-8 sm:gap-3 py-5 px-3 bg-white w-full mx-auto items-center">
        <div className="items-center w-full sm:w-1/2 max-w-[370px] mx-auto">
          <img
            src="/assets/top-fantasticSports-01.png"
            alt="Main Content Background"
            className="mb-3 w-[100%] mx-auto"
          />
          <div className="space-y-1 whitespace-nowrap">
            <p className="text-left text-xs text-secondary font-bold">試合の成績に沿って選手にポイントがつきます。</p>
            <p className="text-left text-xs text-secondary font-bold">
              活躍する選手を選び、自分だけのチームを作りましょう！
            </p>
          </div>
        </div>
        <div className="items-center w-full sm:w-1/2 max-w-[370px] mx-auto">
          <img
            src="/assets/top-fantasticSports-02.png"
            alt="Main Content Background"
            className="mb-3 w-[100%] mx-auto"
          />
          <div className="space-y-1 whitespace-nowrap">
            <p className="text-left text-xs text-secondary font-bold">チームの合計ポイントで他のユーザーと競い合い、</p>
            <p className="text-left text-xs text-secondary font-bold">
              賞金がもらえる上位を目指すスポーツ予想ゲームです！
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
